import { Injectable } from '@angular/core';
import { PaymentMethodName } from '../../enums/payment/payment-method-name';
import { DialogTableDataRow } from '../../interfaces/dialog-table-data-row';
import { TransactionData } from '../../interfaces/transaction/transaction-data';

@Injectable({
  providedIn: 'root'
})
export class TransactionSenderToTableDataMapper {

  public map(transactionData: TransactionData): DialogTableDataRow[] {
    switch (transactionData.paymentMethod) {
      case 'KLARNA':
      case 'PAYPAL':
      case 'APPLEPAY':
      case 'GOOGLEPAY':
      case 'DIRECTTRANSFER':
        return null;
    }

    let dialogTableDataRows: DialogTableDataRow[] = [
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'ACCOUNTHOLDER',
        value: transactionData.accountHolder,
      },
    ];
    switch (transactionData.paymentMethod) {
      case PaymentMethodName.CREDITCARD:
      case PaymentMethodName.CREDITCARD_MOTO:
        dialogTableDataRows.push(
          {
            titleStyleClass: 'font-bold',
            i18nTitleKey: 'CARDNUMBER',
            value: transactionData.cardNumber,
          },
          {
            titleStyleClass: 'font-bold',
            i18nTitleKey: 'EXPIRATIONDATE',
            value: transactionData.expirationDate,
          },
          {
            titleStyleClass: 'font-bold',
            i18nTitleKey: 'CARDTYPE',
            value: transactionData.cardType,
          }
        );
        break
      case PaymentMethodName.SEPA:
      case PaymentMethodName.SEPA_BLACKLIST:
        dialogTableDataRows.push(
          {
            titleStyleClass: 'font-bold',
            title: 'IBAN',
            value: transactionData.iban,
          }
        );
        break;
    }
    return dialogTableDataRows;
  }

}
